import React, { useEffect, useRef, useState } from "react";

import "./theme.css";

import { useDispatch } from "react-redux";
import { setAppColor, setAppMode } from "../../app/themeSlice";

const mode_settings = [
  {
    id: "light",
    name: "Light",
    background: "light-background",
    class: "theme-mode-light",
  },
  {
    id: "dark",
    name: "Dark",
    background: "dark-background",
    class: "theme-mode-dark",
  },
];

const color_templates = [
  {
    id: "cyan",
    name: "Cyan",
    background: "cyan-color",
    class: "theme-color-cyan",
  },
  {
    id: "green",
    name: "Green",
    background: "green-color",
    class: "theme-color-green",
  },
  {
    id: "orange",
    name: "Orange",
    background: "orange-color",
    class: "theme-color-orange",
  },
  {
    id: "blue",
    name: "Blue",
    background: "blue-color",
    class: "theme-color-blue",
  },
  {
    id: "red",
    name: "Red",
    background: "red-color",
    class: "theme-color-red",
  },
  {
    id: "gold",
    name: "Gold",
    background: "gold-color",
    class: "theme-color-gold",
  },
];

const clickOutRef = (content_ref, toggle_ref) => {
  document.addEventListener("mousedown", (e) => {
    if (toggle_ref.current && toggle_ref.current.contains(e.target)) {
      content_ref.current.classList.toggle("active");
    } else {
      if (toggle_ref.current && !content_ref.current.contains(e.target)) {
        content_ref.current.classList.remove("active");
      }
    }
  });
};

const Theme = (props) => {
  const menu_ref = useRef(null);
  const menu_toggle_ref = useRef(null);
  const [currMode, setCurrMode] = useState("light");
  const [currColor, setCurrColor] = useState("cyan");

  const dispatch = useDispatch();

  const openMenu = () => menu_ref.current.classList.add("active");
  const closeMenu = () => menu_ref.current.classList.remove("active");

  clickOutRef(menu_ref, menu_toggle_ref);

  const setMode = (mode) => {
    setCurrMode(mode.id);
    localStorage.setItem("themeMode", mode.class);
    dispatch(setAppMode(mode.class));
  };
  const setColor = (color) => {
    setCurrColor(color.id);
    localStorage.setItem("colorMode", color.class);
    dispatch(setAppColor(color.class));
  };

  useEffect(() => {
    const themeClass = mode_settings.find(
      (e) => e.class === localStorage.getItem("themeMode", "theme-mode-light")
    );
    const colorClass = color_templates.find(
      (e) => e.class === localStorage.getItem("colorMode", "theme-mode-light")
    );

    if (themeClass !== undefined) {
      setCurrMode(themeClass.id);
    }
    if (colorClass !== undefined) {
      setCurrColor(colorClass.id);
    }
  }, []);

  return (
    <div>
      <button
        ref={menu_toggle_ref}
        className="ez-dropdown-toggle"
        onClick={() => openMenu()}
      >
        <i className="bx bx-palette"></i>
      </button>

      <div
        ref={menu_ref}
        onClick={() => {
          closeMenu();
        }}
        className="theme-menu"
      >
        <h4>Theme Settings</h4>
        <button className="theme-menu-close">
          <i className="bx bx-x"></i>
        </button>

        <div className="theme-menu-select">
          <span>Choose Mode</span>
          <ul className="mode-list">
            {mode_settings.map((item, index) => (
              <li key={index} onClick={() => setMode(item)}>
                <div
                  className={`mode-list-color ${item.background} ${
                    item.id === currMode ? "active" : ""
                  }`}
                >
                  <i className="bx bx-check"></i>
                </div>
                <span>{item.name}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="theme-menu-select">
          <span>Choose Color</span>
          <ul className="mode-list">
            {color_templates.map((item, index) => (
              <li key={index} onClick={() => setColor(item)}>
                <div
                  className={`mode-list-color ${item.background} ${
                    item.id === currColor ? "active" : ""
                  }`}
                >
                  <i className="bx bx-check"></i>
                </div>
                <span>{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Theme;
